export default __webpack_public_path__ + "static/media/auth-flow-icon-filled.b5627774.svg";